import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import JobsTable from './jobs-table.jsx';


if (document.getElementById('react-component-g4-logistics-portal-unsent-jobs')) {
  ReactDOM.render(<JobsTable
    url= "/api/v1/portal/jobs/unsent"
    infiniteScroll={true}
    message_if_none = 'No jobs that are unsent.'
  />,
document.getElementById('react-component-g4-logistics-portal-unsent-jobs'));
}
